import { useCallback, memo } from 'react';
import { SkuDistrictReportGridData } from '@pages/reporting-pages/deliveries-sku-district/types/SkuDistrictReportGridData';
import { renderKilogramsToTonnes, numberWithSpaces } from 'components/global/utils';
import CellPercentBar from 'components/cell-percent-bar/CellPercentBar';



interface GridRowProps {
	item: SkuDistrictReportGridData,
	rowIndex: number,
}
  

const GridRow = (props: GridRowProps) => {
	const { rowIndex } = props;
	const { executionPlaceName, country,
		total_volume, total_volumePct, total_weight, total_ordersCount } = props.item;

	const getClassName = useCallback((centered: boolean, leftAlign: boolean = false) => 
		`app-grid-cell${
			rowIndex % 2 == 0 ? ' secondary-cell' : ' primary-cell'
		}${
			leftAlign ? ' left-align-cell' : ''
		}${
			centered ? ' centered-cell' : ''
		}`
	,[ rowIndex ]);


	return (
		<>
			<div className={getClassName(true)}>
				<p>{country}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{executionPlaceName}</p>
			</div>

			
			<CellPercentBar
				cellClassName={getClassName(true)}
				value={total_volume}
				percentValue={total_volumePct} />

			<div className={getClassName(true)}>
				<p>{renderKilogramsToTonnes(total_weight)}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{numberWithSpaces(total_ordersCount)}</p>
			</div>
		</>
	)
}

export default memo(GridRow);